<template>
  <div class="file">
    <!-- 文档管理 开始 -->
    <el-card class="file-manage">
      <div slot="header"
           class="clearfix">
        <span>个人内容库</span>
      </div>
      <div class="tool-bar">
        <div class="left-bar">
          <span @click="goBack"
                v-if="showBackBtn">
            <i class="el-icon-back"
               style="font-size:16px"></i>{{$t('docMgt.back')}}
          </span>
          <span @click="uploadClick()" v-if="perList.includes('1-1') && modalInfo !== 2">
            <i class="iconfont icon-gn_upload"></i>{{$t('docMgt.fileUpload.upload')}}
          </span>
          <span @click="createFolder"
                v-if="(selectedFileList.length === 0 || (selectedFileList.length === 1 && selectedFileList[0].fileType === 1)) && perList.includes('1-3') && modalInfo !== 2">
            <i style="font-size:16px"
               class="el-icon-folder-add"></i>{{$t('docMgt.newFolder.newFolder')}}
          </span>
          <!-- <span @click="reFresh()"
                v-if="selectedFiles.length===1 && !selectedFileList[0].fileType !== 2 && perList.includes('1-4') && modalInfo !== 2">
            <i style="font-size:16px"
               class="el-icon-refresh"></i>{{$t('docMgt.update.update')}}
          </span> -->
          <span @click="downloadFile()" v-if="selectedFiles.length===1 && perList.includes('1-2') && selectedFileList[0].fileType !== 2">
            <i class="iconfont icon-gn_download"></i>{{$t('docMgt.download')}}
          </span>
          <span @click="reName()"
                v-show="selectedFiles.length===1 && perList.includes('1-6') && modalInfo !== 2">
            <i style="font-size:16px"
               class="el-icon-edit"></i>{{$t('docMgt.rename.name')}}
          </span>
          <span v-show="selectedFiles.length === 1 && !selectedFileList[0].fileType === 1 && perList.includes('1-5') && modalInfo !== 2"
                @click="versionClick()">
            <i class="iconfont icon-gn_version1"></i>{{$t('docMgt.hisVis.hisVis')}}
          </span>
          <span v-show="selectedFiles.length > 0 && concat && canConcat" @click="getBitByGlid(2 ,selectedFileList)">
            <i class="iconfont icon-icon_moxing"></i>{{$t('docMgt.relate')}}
          </span>
          <span v-show="selectedFiles.length > 0 && !concat && canConcat && modalInfo === 1" @click="cancelConcat(selectedFileList)">
            <i class="iconfont icon-icon_moxing"></i>{{$t('docMgt.cancleRelate')}}
          </span>
          <span @click="deleteShowClick('')"
                v-show="selectedFiles.length >= 1 && perList.includes('1-7') && modalInfo !== 2">
            <i class="iconfont icon-gn_delete"></i>{{$t('instrData.del')}}
          </span>
        </div>
        <!-- <div class="right-bar">
          <span :style="!isList? 'color:#003580': ''">
            <i @click="changeListModel(0)"
               class="iconfont icon-qieh-3"></i>
          </span>
          <span :style="isList? 'color:#003580': ''">
            <i @click="changeListModel(1)"
               class="iconfont icon-qieh-2"></i>
          </span>
        </div> -->
      </div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <span :style="folderId === '0'? 'color: #fff': 'color: rgba(255, 255, 255, 0.65)'"
                @click="goMainFolder()">个人内容库</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item v-for="(i, index) in breadList" :key="index"><span :style="folderId === i.id? 'color: #fff': 'color: rgba(255, 255, 255, 0.65)'" @click="goFolder(i.id, index)">{{i.name}}</span></el-breadcrumb-item>
        <!-- 搜索 -->
        <!-- <div class="search-part" v-if="canConcat">
          <el-input :placeholder="$t('docMgt.enterContent')" v-model="searchStr"></el-input>
          <el-link :underline="false" icon="el-icon-search" @click="searchClick"></el-link>
        </div> -->
      </el-breadcrumb>
      <div class="main-cont">
        <el-table ref="multipleTable"
                  :data="docList"
                  tooltip-effect="dark"
                  style="width: 100%"
                  height="400"
                  :empty-text="noData"
                  header-row-class-name="headers"
                  @selection-change="handleSelectionChange"
                  @cell-mouse-enter="handleMouseEnter"
                  @cell-mouse-leave="handleMouseLeave"
                  v-if="isList">
          <el-table-column type="selection"
                          width="45"></el-table-column>
          <el-table-column :label="$t('docMgt.docNum')"
                          width="150">
            <template slot-scope="scope">
              <div class="fileName">
                <div class="file-status">
                </div>
                <div v-if="scope.row.status"
                    class="icon-btn">
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="version"
                          :label="$t('docMgt.name')"
                          width="400">
            <template slot-scope="scope">
              <div class="file-info" style="cursor:pointer"
                      @click="previewClick(scope.row)">
                <img v-if="scope.row.fileType === 2" src="../../assets/images/file/folder.png" alt="">
                <!-- <img v-else src="../../assets/images/file/no.png" alt=""> -->
                <img v-if="scope.row.ext && fileTypeList.includes(scope.row.ext)"
                    :src="require(`../../assets/images/file/${scope.row.ext.toLowerCase()}.png`)"
                    alt="">
                <img v-if="scope.row.ext && !fileTypeList.includes(scope.row.ext)" src="../../assets/images/file/no.png" alt="">
                <span>{{scope.row.fileType === 2 ? scope.row.name : scope.row.name + '.' + scope.row.ext}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('docMgt.modifyTime')" width="150">
            <template slot-scope="scope">
              <div>{{(scope.row.modifyTime) | dateFormat('yyyy-M-d hh:mm')}}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('docMgt.docSize')" width="100">
            <template slot-scope="scope">
              <div>
                {{scope.row.size + ' KB'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('docMgt.creatUser')" width="200">
            <template slot-scope="scope">
              <div>
                {{scope.row.userName}}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('docMgt.mark')">
            <template slot-scope="scope">
              <div>
                {{ scope.row.remark }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block-content"
            v-else>
          <div class="block-list"
              v-if="docList.length !== 0">
            <div @dblclick="previewClick(i)"
                class="file"
                v-for="(i, index) in docList"
                @mouseover='currentIndex = index'
                @mouseleave="currentIndex = null"
                :class="i.checked?'checked-file':''"
                :key="index">
              <img v-if="i.fileType === 1" src="../../assets/images/file/folder.png" alt="">
              <img v-else src="../../assets/images/file/no.png" alt="">
              <!-- <img v-if="i.FolderId"
                  src="../../assets/images/file/folder.png"
                  alt="">
              <img v-if="i.FileExtName && fileTypeList.includes(i.FileExtName.substr(1))"
                  :src="require(`../../assets/images/file/${i.FileExtName.substr(1).toLowerCase()}.png`)"
                  alt="">
              <img v-if="i.FileExtName && !fileTypeList.includes(i.FileExtName.substr(1))" src="../../assets/images/file/no.png" alt=""> -->
              <span class="file_name" :title="i.docName">{{i.docName}}</span>
              <span v-if="currentIndex === index || i.checked"
                    class="file_check">
                <i @click="checkedFile(i.id, i.fileType)"
                  v-if="!i.checked"
                  class="iconfont icon-sp_uncheck"
                  style="color: #ccc"></i>
                <i @click="checkedFile(i.id, i.fileType)"
                  class="iconfont icon-sp_checked"
                  v-if="i.checked"
                  style="color: #103674"></i>
              </span>
            </div>
          </div>
          <div class="block-list-null"
              v-else>
            <span>{{ $t('docMgt.noData') }}</span>
          </div>
        </div>
        <!-- <div class="vision" v-if="visionShow">
          <div class="vision-title">
            <span>{{$t('docMgt.hisVis.hisVis')}}</span>
            <el-button @click="visionShow = false" type=text><i class="el-icon-close"></i></el-button>
          </div>
          <div class="vision-wrap">
            <div class="vision-list" v-for="(i, index) in visionData" :key="index">
              <div>
                <span class="prew" @click="preview(i)">V{{i.verNum.toFixed(1)}}</span>
                <span>{{stampTime(Number(i.createTime.substr(6, 13)))}}</span>
                <span>{{i.createOperator}}</span>
              </div>
              <div>
                <span v-if="index !== 0" @click="rollBack(i)"><i class="el-icon-back"></i>回滚</span>
                <span @click="downloadVisionFile(i)"><i class="iconfont icon-gn_download"></i>{{$t('docMgt.download')}}</span>
                <span @click="deleteVision(i)" v-if="index !== 0"><i class="el-icon-delete"></i>{{$t('docMgt.del')}}</span>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 40, 60]"
        :page-size="linit"
        :hide-on-single-page="true"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </el-card>
    <person-upload v-show="showUploadDia" :fileTypeList="fileTypeList" :folderId='folderId' :uploadFile='uploadFile' @showUploadDiaFun="showUploadDiaFun" @closeUploadDia="closeUploadDia" @freshFolder="getPersonDocList"></person-upload>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
import {
  mapMutations
} from 'vuex'
export default {
  name: 'SkyDrive',
  props: {
    modalInfo: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      currentMenu: '',
      searchStr: null,
      currentPage: 1,
      totalCount: 0,
      linit: 20,
      docList: [],
      failShow: false,
      selectedFiles: [], // 多选文件名
      selectedFileList: [],
      isVersionData: false,
      isList: true,
      listModel: 1,
      currentIndex: null,
      preFile: null,
      showBackBtn: false,
      folderId: '0',
      folderInfo: null,
      breadList: [],
      fileTypeList: [
        'doc', 'docx', '3gp', 'ai', 'avi', 'bmp', 'dwg', 'dxf', 'eps', 'flv', 'gif', 'jpg', 'mov', 'pptx', 'mpeg2', 'mpeg4', 'pdf', 'png', 'ppt', 'psd', 'rm', 'rmvb', 'svg', 'txt', 'webp', 'wmv', 'word', 'xls', 'xlsx', 'zip', 'jpeg'
      ],
      visionShow: false,
      visionData: [],
      checkList: [],
      selectTag: [],
      concat: false,
      canConcat: true,
      concatList: [],
      perList: [],
      uploadFile: [],
      uploadNum: 0, //记录点击上传按钮的次数
      showUploadDia: false,
      searchBit: '',
      options: [],
      hotSearch: null,
      loading: false,
      noData: '加载中...',
      isSearch: false
    }
  },
  computed: {
    newDocList() {
      return this.$store.state.reloadFile
    },
    newVision() {
      return this.$store.state.reloadVision
    }
  },
  watch: {
    newDocList: function(val) {
      if (val) {
        this.getPersonDocList()
      }
    },
    newVision: function(val) {
      this.getDocVisList(val)
    }
  },
  created() {
    this.perList = this.$store.state.perList
    if (window.clickGlids) {
      this.concat = true
    }
    if (this.modalInfo === 1) {
      this.concat = false
      this.getBitByGlid(1)
    } else {
      this.getPersonDocList()
    }
  },
  methods: {
    ...mapMutations(['showModal']),
    handleSizeChange(val) {
      this.linit = val
      if (!this.isSearch) {
        this.getPersonDocList()
      } else {
        this.searchData()
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      if (!this.isSearch) {
        this.getPersonDocList()
      } else {
        this.searchData()
      }
    },
    showUploadDiaFun(data) {
      this.showUploadDia = data
    },
    closeUploadDia(data) {
      this.uploadFile = []
      this.showUploadDia = data.showStatus
    },
    // 禁用键盘事件
    enableKeyboard(val) {
      window.SetKeyBoardEnable(val)
    },
    // 关联文档
    getBitByGlid(type, row) {
      if (!window.clickGlids) {
          this.$message({
            message: '请选择构件',
            type: 'error'
          })
        return
      }
      ApiService.doc.getModelData({
        glid: window.clickGlids,
        BitNumber: '',
        mileageID: window.R_config.modelId
      }).then(res => {
        if (type === 1) {
          if (res.code !== 0) {
            this.noData = this.$t('docMgt.noData')
            return
          }
          this.searchBit = res.data.BitNumber
          this.getDocListByGlid(res.data.BitNumber)
        } else if (type === 2) {
          if (res.code !== 0) {
            this.$message({
              message: '暂不可关联',
              type: 'warn'
            })
            return
          }
          this.fileConcat(row, res.data.BitNumber)
        }
      })
    },
    // 取消关联
    cancelConcat(val) {
      let fids = []
      val.map(n => {
        fids.push({
          ID: n.sID,
          FID: n.id
        })
      })
      ApiService.doc.cancelConcat({
        reqList: fids
      }).then(res => {
        if (res.code === 0) {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.getDocListByGlid(this.searchBit)
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    // 通过位号查询关联文档
    getDocListByGlid(bit) {
      this.canConcat = false
      var arr = []
      ApiService.doc.searchDocByBitNum({
        BitNumber: bit
      }).then(res => {
        if (res.code !== 0) {
          this.noData = this.$t('docMgt.noData')
          this.totalCount = 0
          this.docList = []
          return
        }
        // let fids = res.data.map(n => {
        //   return n.FID
        // })
        // this.docList = []
        let fileArr = res.data
          res.data.forEach(n => {
            ApiService.oct_doc.getDocInfoByFid({
              did: n.FID
            }).then(res => {
              // console.log(res)
              res.data.sID = n.FID
              res.data.isRelate = n.Shows
              res.data.docCode = n.DocumentCode
              arr = arr.concat(res.data)
              this.docList = arr
            })
          })
          // this.docList = res.
      })
    },
    // 设置默认选中
    setCurrent(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.setCurrentRow(row)
        })
      }
    },
    // 选择文件
    checkedFile(val) {
      this.preFile = null
      let a = []
      let b = []
      this.docList.map(n => {
        if (n.id === val) {
          n.checked = !n.checked
        }
        if (n.checked) {
          a.push(n.id)
          b.push(n)
          this.preFile = n
        } else if (a.length !== 0 && n.checked) {
          a.remove(n.id)
          b.remove(n)
        }
      })
      this.selectedFiles = a
      this.selectedFileList = b
    },
    // 创建文件夹
    createFolder() {
      if (!this.folderInfo) {
        this.folderInfo = {
          id: '0',
          path: '/'
        }
      }
      this.showModal({
        name: 'personNewFolder',
        show: true,
        top: '2.5rem',
        data: this.folderInfo
      })
    },
    // 更改列表视图
    changeListModel(val) {
      if (this.listModel === val) return false
      this.listModel = val
      this.isList = !this.isList
      this.selectedFiles = []
      this.selectedFileList = []
    },
    // 更新文件
    reFresh() {
      if (this.selectedFileList[0].FolderId) return false
      this.showModal({
        name: 'refresh',
        show: true,
        top: '3rem',
        left: '',
        data: this.selectedFileList
      })
    },
    // 查看操作日志
    getActLog() {
      this.showModal({
        name: 'actlog',
        show: true,
        top: '2.5rem',
        data: this.selectedFileList[0]
      })
    },
    // 文件重命名
    reName() {
      this.showModal({
        name: 'personRename',
        show: true,
        top: '3rem',
        data: this.selectedFileList[0]
      })
    },
    // 排序算法 文件编号
    handleSortNum(a, b) {
      return Number(a.FileId)
    },
    // 排序 时间
    handleSortTime(a) {
      return new Date(a.FileModifyTime).getTime()
    },
    searchClick() {
      this.currentPage = 1
      this.linit = 20
      this.isSearch = true
      this.searchData()
    },
    // 搜索
    searchData() {
      if (!this.searchStr) {
        this.isSearch = false
        this.getPersonDocList()
        return
      }
      ApiService.oct_doc.searchDoc({
        searchKey: this.searchStr,
        page: this.currentPage,
        linit: this.linit
      }).then(res => {
        if (res.code === 0) {
          this.docList = res.data
          this.totalCount = res.count
        } else {
          this.docList = []
          this.totalCount = 0
          this.noData = this.$t('docMgt.noData')
        }
      })
    },
    // 处理时间
    stampTime(time) {
      if (!time) {
        return
      }
      var date = new Date(time)
      var Y = date.getFullYear() + '-'
      var M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      var h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    // 返回默认文档列表
    goBack() {
      this.currentPage = 1
      this.linit = 20
      if (this.breadList.length === 1) {
        this.breadList.splice(0,1)
        this.currentMenu = false
        this.showBackBtn = false
        this.folderId = '0'
        this.folderInfo = {
          id: '0'
        }
      } else if (this.breadList.length > 1) {
        this.breadList = this.breadList.slice(0, this.breadList.length - 1)
        this.folderId = this.breadList[this.breadList.length - 1].id
        this.folderInfo = {
          id: this.breadList[this.breadList.length - 1].id,
        }
      }
      this.getPersonDocList()
    },
    // 返回根目录
    goMainFolder() {
      this.currentPage = 1
      this.linit = 20
      this.breadList = []
      this.currentMenu = false
      this.showBackBtn = false
      this.folderId = '0'
      this.getPersonDocList()
    },
    // 前往文件夹
    goFolder(val, index) {
      if (this.folderId === val) return false
      this.currentPage = 1
      this.linit = 20
      this.breadList.splice(index + 1)
      this.folderId = val
      this.getPersonDocList()
    },
    // 查找文件夹下的所有文件
    getFolderChildren(val) {
      // console.log(val)
      this.folderInfo = val
      this.folderId = val.id
      ApiService.person_doc.getPersonDoc({
        parentID: String(this.folderId),
        userId: JSON.parse(localStorage.user).userId,
        fileName: '',
        fileType: 0,
        pageIndex: this.currentPage,
        pageSize: this.linit
      }).then(res => {
        if (res.code === 0) {
          let arr = []
          res.data.map(n => {
            n.status = false
            n.checked = false
            arr.push(n.id)
          })
          this.docList = res.data
          this.totalCount = res.data.count
        } else {
          this.totalCount = 0
          this.noData = this.$t('docMgt.noData')
          this.docList = []
        }
        this.breadList.push({
          name: val.name,
          id: val.id
        })
        this.currentMenu = val.name
        this.showBackBtn = true
      })
    },
    checkRelevance(docId) {
      ApiService.doc.fileCheck({
        FileIDs: docId
      }).then(res => {
        this.checkList = res.data
      })
    },
    downloadFile() {
      // console.log(this.selectedFiles)
      ApiService.person_doc.fileDownload({
        id: this.selectedFiles
      }).then(res => {
        if (res.code === 0) {
          let link = document.createElement("a")
          let body = document.querySelector("body")
          link.href = res.data
          link.download = '文件夹'
          link.style.display = "none"
          body.appendChild(link)
          link.click()
          body.removeChild(link)
        }
      })
    },
    // 获得文件和文件夹列表
    getPersonDocList() {
      ApiService.person_doc.getPersonDoc({
        parentID: String(this.folderId),
        userID: JSON.parse(localStorage.user).userId,
        fileName: '',
        fileType: 0,
        pageIndex: this.currentPage,
        pageSize: this.linit
      }).then(res => {
        if (res.code === 0) {
          this.docList = res.data
          this.totalCount = res.count
        } else {
          this.docList = []
          this.totalCount = 0
          this.noData = this.$t('docMgt.noData')
        }
      })
    },
    versionClick(row) {
      if (row) {
        this.getDocVisList(row.FileId)
      } else {
        this.getDocVisList(this.selectedFiles[0])
      }
    },
    // 获得文档历史版本列表
    getDocVisList(docID) {
      let params = new FormData()
      params.append('module', 'VersionManager')
      params.append('fun', 'GetFileVersionByPageSize')
      params.append('fileId', docID)
      params.append('currentPage', 1)
      params.append('pageSize', 99)
      ApiService.oct_doc.common(params).then(res => {
        this.visionShow = true
        res.fileVersion.map(n => {
          n.FileId = n.fileId
        })
        this.visionData = res.fileVersion
      })
    },
    // 删除某个版本
    deleteVision(val) {
      this.showModal({
        name: 'deletevision',
        show: true,
        top: '2.5rem',
        left: '',
        data: val
      })
    },
    // 回滚版本
    rollBack(val) {
      this.showModal({
        name: 'setcurrentfile',
        show: true,
        top: '2.5rem',
        left: '',
        data: val
      })
    },
    // 上传按钮
    uploadClick() {
      if (!this.folderInfo) {
        this.folderInfo = {
          id: '0',
          path: '/'
        }
      }
      this.showModal({
        name: 'personUpload',
        show: true,
        top: '2.5rem',
        left: '',
        data: this.folderInfo
      })
    },
    // 鼠标进入单元格事件
    handleMouseEnter(row, column, cell, event) {
      row.status = true
    },
    // 鼠标离开单元格事件
    handleMouseLeave(row, column, cell, event) {
      row.status = false
    },
    // 获得文件选择状态
    handleSelectionChange(selection) {
      this.canConcat = true
      let a = []
      this.selectedFileList = selection
      selection.map(n => {
        if (n.fileType === 2) this.canConcat = false
        a.push(n.id)
        return
      })
      this.selectedFiles = a
    },
    previewClick(val) {
      this.currentPage = 1
      this.linit = 20
      if (val.fileType === 2) {
        this.getFolderChildren(val)
        return false
      }
      if (val.fileType === 1) {
        if ( val.ext.toLowerCase() === 'pdf' || val.ext.toLowerCase() === 'doc' || val.ext.toLowerCase() === 'docx' || val.ext.toLowerCase() === 'rtf' || val.ext.toLowerCase() === 'xls' || val.ext.toLowerCase() === 'xlsx' || val.ext.toLowerCase() === 'ppt' || val.ext.toLowerCase() === 'pptx' || val.ext.toLowerCase() === 'txt' || val.ext.toLowerCase() === 'wps') {
          window.open('../../static/preview.html?fileUrl=' + val.path)
        } else {
          window.open(val.path)
        }
      }
    },
    // 删除文件
    deleteShowClick(val) {
      this.$confirm('确认删除吗？', '删除文件', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let a = this.selectedFileList.map(n => {
          return  n.id
        })
        ApiService.person_doc.delFile({
          userID: JSON.parse(localStorage.user).userId,
          id: a
        }).then(res => {
          this.getPersonDocList()
        })
      }).catch(() => {
      })
    },
    // 文档关联
    fileConcat(val, bit) {
      let params = {
        glid: bit
      }
      if (val.length) {
        params.pamData = val.map(n => {
          return {
            FID: n.id,
            FileName: n.name + '.' + n.ext,
            DocumentCode: n.docCode || ''
          }
        })
      } else {
        params.pamData = [
          {
            FID: val.id,
            FileName: val.name + '.' + val.ext,
            DocumentCode: n.docCode || ''
          }
        ]
      }
      ApiService.doc.fileUpdateCheck(params).then(res => {
        if (res.code === 0) {
          this.$message({
            message: '关联成功',
            type: 'success'
          })
          this.getPersonDocList()
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    // 设置权限
    setPermission() {
      this.showModal({
        name: 'filePermission',
        show: true,
        top: '2rem',
        data: this.selectedFileList[0]
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../common/css/color.scss';
.file {

  .file-manage {
    width: 1300px;
    .fileName {
      display: flex;
      flex-flow: row;
      justify-content: space-between;

      .file-status {
        display: flex;
        flex-flow: row;

        span {
          font-family: "Microsoft YaHei";
          font-size: 14px;
          color: #6b7d99;
        }
      }

      .status {
        span {
          margin-left: 10px;

          i {
            margin-right: 6px;
          }
        }
      }

      .icon-btn {
        margin-right: 10px;

        i {
          margin-left: 16px;
          cursor: pointer;
        }

        i:hover {
          color: rgb(0, 53, 128);
        }
      }
    }

    .el-card__body {
      height: 495px;

      .tool-bar {
        height: 32px;
        display: flex;
        line-height: 32px;
        justify-content: space-between;
        padding: 0 10px;
        font-size: 12px;
        color: #888;
        background: $card_body;
        .left-bar {
          display: flex;
          span {
            cursor: pointer;
            margin-right: 20px;
            display: flex;
            align-items: center;
            padding: 0 15px;
            background: $card_header;
            color: $font_color;
            i {
              margin-right: 5px;
            }
          }

          span:hover {
            background:  $btn_hover;
          }

        }

        .right-bar {
          span {
            margin-left: 10px;
          }
        }
      }

      .el-breadcrumb {
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        padding: 0 10px;
        margin: 10px 0;
        border: 0;

        .search-part {
          height: 30px;
          width: 320px;
          display: flex;
          align-items: center;
          float: right;
          .el-input {
            width: 300px;
            .el-input__inner {
              padding: 0 10px;
              height: 22px;
              line-height: 22px;
              font-size: 12px;
            }
          }
          .el-link {
            padding: 3px;
            border: 1px solid #DCDFE6;
            border-radius: 4px;
          }
        }
        .el-breadcrumb__item {
          span {
            font-weight: normal;
            cursor: pointer;
            color: #fff;
          }
        }
      }
      
      .el-table--enable-row-hover .el-table__body tr:hover>td {
        background-color: rgba(255,255,255,.2);
      }
      .el-table {
        background: transparent;
        &:before {
          background-color: rgba(255, 255, 255, 0.12);
        }
        td {
          border-bottom: 1px solid rgba(255, 255, 255, 0.12);
          color: rgba(255, 255, 255, 0.65);
        }
        tr {
          background: transparent;
        }
        th.is-leaf {
          border-bottom: 0;
        }
        // thead {
        //   color: rgba(255, 255, 255, 0.85);
        //   background: rgba(255, 255, 255, 0.04);
        // }
        .cell {
          word-break: break-word;
        }
        .headers {
          th {
            padding: 10px 0;
            height: 29px;
            line-height: 29px;
            color: rgba(255, 255, 255, 0.85);
            background: rgba(255, 255, 255, 0.04);
          }
        }
        .file-info {
          display: flex;
          align-items: center;
          justify-content: start;
          img {
            // width: 20px;
            height: 20px;
            display: block;
            margin-right: 5px;
            flex-shrink:0;
          }
          span: {
            padding: 0 5px;
            display: block;
          }
        }
      }
      .main-cont {
        position: relative;
        height: 400px;
      }
      .checked-file {
        background: #f0f0f0;
      }
    }
  }
}
.search-proper {
  max-width: 300px !important;
  .el-select-dropdown__item {
    white-space: normal;
    line-height: 20px;
    height: auto;
    margin-bottom: 10px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/user/personDrive.vue